import { Button, ButtonProps } from '@mui/material';
import React from 'react';

export const LandingButton: React.FC<ButtonProps> = ({ children, ...props }) => {

  return (
    <Button sx={{
      width: 160,
      padding: 3,
      paddingBlock: 1,
      backgroundColor: '#000000',
      color: '#FFFFFF',
      border: '1px solid #FFFFFF',
      '&:hover': {
        backgroundColor: '#FFFFFF',
        color: '#000000',
      },
      textTransform: 'none'
    }}
    {...props}
    >
      {children}
    </Button>
  )
};
